/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class InternalQueryServiceAPI
 * @hideconstructor
 * @classdesc API class that is used to execute queries.
 */
define([], () => {
	class InternalQueryServiceAPI {

		/**
		 * @function InternalQueryServiceAPI#executeQuery
		 * @description Execute query.
		 * @async
		 *
		 * @param {String} sourceId: The sourceId with which query is based on
		 * @param {Object} querySpec The query specification.
		 * @param {String} [senderId] The unique string identifier of the the query sender
		 * @returns {Promise<Object>} Returns a promise resolved with a JSON object from server
		 */
		executeQuery() {}
	}

	return InternalQueryServiceAPI;
});
